export type CountryInfo = {
  id: string;
  name: string;
  flag: string;
};

// Country ids come from the provider, and this table maps them to a name and a flag.
//
// It was wrong for 163 of 195 ids — the list had drifted out of alignment, so id 198 was
// labelled "España 🇪🇸" when the provider means Samoa. Customers picked a country and
// were sold a different one: a real purchase on 2026-08-17 asked for Spain and got
// +685. Regenerated from the provider's own getCountries, which is the only list that
// can be right, and `npm run check:countries` now fails if it drifts again.
export const COUNTRIES_MAP: Record<string, { name: string; flag: string }> = {
  "1": { name: "Ucrania", flag: "🇺🇦" },
  "2": { name: "Kazajistán", flag: "🇰🇿" },
  "3": { name: "China", flag: "🇨🇳" },
  "4": { name: "Filipinas", flag: "🇵🇭" },
  "5": { name: "Myanmar", flag: "🇲🇲" },
  "6": { name: "Indonesia", flag: "🇮🇩" },
  "7": { name: "Malasia", flag: "🇲🇾" },
  "8": { name: "Kenia", flag: "🇰🇪" },
  "9": { name: "Tanzania", flag: "🇹🇿" },
  "10": { name: "Vietnam", flag: "🇻🇳" },
  "11": { name: "Kirguistán", flag: "🇰🇬" },
  "13": { name: "Israel", flag: "🇮🇱" },
  "14": { name: "Hong Kong", flag: "🇭🇰" },
  "15": { name: "Polonia", flag: "🇵🇱" },
  "16": { name: "Reino Unido", flag: "🇬🇧" },
  "17": { name: "Madagascar", flag: "🇲🇬" },
  "18": { name: "RD del Congo", flag: "🇨🇩" },
  "19": { name: "Nigeria", flag: "🇳🇬" },
  "20": { name: "Macao", flag: "🇲🇴" },
  "21": { name: "Egipto", flag: "🇪🇬" },
  "22": { name: "India", flag: "🇮🇳" },
  "23": { name: "Irlanda", flag: "🇮🇪" },
  "24": { name: "Camboya", flag: "🇰🇭" },
  "25": { name: "Laos", flag: "🇱🇦" },
  "26": { name: "Haití", flag: "🇭🇹" },
  "27": { name: "Costa de Marfil", flag: "🇨🇮" },
  "28": { name: "Gambia", flag: "🇬🇲" },
  "29": { name: "Serbia", flag: "🇷🇸" },
  "30": { name: "Yemen", flag: "🇾🇪" },
  "31": { name: "Sudáfrica", flag: "🇿🇦" },
  "32": { name: "Rumanía", flag: "🇷🇴" },
  "33": { name: "Colombia", flag: "🇨🇴" },
  "34": { name: "Estonia", flag: "🇪🇪" },
  "35": { name: "Azerbaiyán", flag: "🇦🇿" },
  "36": { name: "Canadá", flag: "🇨🇦" },
  "37": { name: "Marruecos", flag: "🇲🇦" },
  "38": { name: "Ghana", flag: "🇬🇭" },
  "39": { name: "Argentina", flag: "🇦🇷" },
  "40": { name: "Uzbekistán", flag: "🇺🇿" },
  "41": { name: "Camerún", flag: "🇨🇲" },
  "42": { name: "Chad", flag: "🇹🇩" },
  "43": { name: "Alemania", flag: "🇩🇪" },
  "44": { name: "Lituania", flag: "🇱🇹" },
  "45": { name: "Croacia", flag: "🇭🇷" },
  "46": { name: "Suecia", flag: "🇸🇪" },
  "47": { name: "Iraq", flag: "🇮🇶" },
  "48": { name: "Países Bajos", flag: "🇳🇱" },
  "49": { name: "Letonia", flag: "🇱🇻" },
  "50": { name: "Austria", flag: "🇦🇹" },
  "51": { name: "Bielorrusia", flag: "🇧🇾" },
  "52": { name: "Tailandia", flag: "🇹🇭" },
  "53": { name: "Arabia Saudita", flag: "🇸🇦" },
  "54": { name: "México", flag: "🇲🇽" },
  "55": { name: "Taiwán", flag: "🇹🇼" },
  "56": { name: "España", flag: "🇪🇸" },
  "57": { name: "Irán", flag: "🇮🇷" },
  "58": { name: "Argelia", flag: "🇩🇿" },
  "59": { name: "Eslovenia", flag: "🇸🇮" },
  "60": { name: "Bangladesh", flag: "🇧🇩" },
  "61": { name: "Senegal", flag: "🇸🇳" },
  "62": { name: "Turquía", flag: "🇹🇷" },
  "63": { name: "Chequia", flag: "🇨🇿" },
  "64": { name: "Sri Lanka", flag: "🇱🇰" },
  "65": { name: "Perú", flag: "🇵🇪" },
  "66": { name: "Pakistán", flag: "🇵🇰" },
  "67": { name: "Nueva Zelanda", flag: "🇳🇿" },
  "68": { name: "Guinea", flag: "🇬🇳" },
  "69": { name: "Malí", flag: "🇲🇱" },
  "70": { name: "Venezuela", flag: "🇻🇪" },
  "71": { name: "Etiopía", flag: "🇪🇹" },
  "72": { name: "Mongolia", flag: "🇲🇳" },
  "73": { name: "Brasil", flag: "🇧🇷" },
  "74": { name: "Afganistán", flag: "🇦🇫" },
  "75": { name: "Uganda", flag: "🇺🇬" },
  "76": { name: "Angola", flag: "🇦🇴" },
  "77": { name: "Chipre", flag: "🇨🇾" },
  "78": { name: "Francia", flag: "🇫🇷" },
  "79": { name: "Papúa Nueva Guinea", flag: "🇵🇬" },
  "80": { name: "Mozambique", flag: "🇲🇿" },
  "81": { name: "Nepal", flag: "🇳🇵" },
  "82": { name: "Bélgica", flag: "🇧🇪" },
  "83": { name: "Bulgaria", flag: "🇧🇬" },
  "84": { name: "Hungría", flag: "🇭🇺" },
  "85": { name: "Moldavia", flag: "🇲🇩" },
  "86": { name: "Italia", flag: "🇮🇹" },
  "87": { name: "Paraguay", flag: "🇵🇾" },
  "88": { name: "Honduras", flag: "🇭🇳" },
  "89": { name: "Túnez", flag: "🇹🇳" },
  "90": { name: "Nicaragua", flag: "🇳🇮" },
  "91": { name: "Timor Oriental", flag: "🇹🇱" },
  "92": { name: "Bolivia", flag: "🇧🇴" },
  "93": { name: "Costa Rica", flag: "🇨🇷" },
  "94": { name: "Guatemala", flag: "🇬🇹" },
  "95": { name: "Emiratos Árabes Unidos", flag: "🇦🇪" },
  "96": { name: "Zimbabue", flag: "🇿🇼" },
  "97": { name: "Puerto Rico", flag: "🇵🇷" },
  "98": { name: "Sudán", flag: "🇸🇩" },
  "99": { name: "Togo", flag: "🇹🇬" },
  "100": { name: "Kuwait", flag: "🇰🇼" },
  "101": { name: "El Salvador", flag: "🇸🇻" },
  "102": { name: "Libia", flag: "🇱🇾" },
  "103": { name: "Jamaica", flag: "🇯🇲" },
  "104": { name: "Trinidad y Tobago", flag: "🇹🇹" },
  "105": { name: "Ecuador", flag: "🇪🇨" },
  "106": { name: "Esuatini", flag: "🇸🇿" },
  "107": { name: "Omán", flag: "🇴🇲" },
  "108": { name: "Bosnia y Herzegovina", flag: "🇧🇦" },
  "109": { name: "República Dominicana", flag: "🇩🇴" },
  "110": { name: "Siria", flag: "🇸🇾" },
  "111": { name: "Catar", flag: "🇶🇦" },
  "112": { name: "Panamá", flag: "🇵🇦" },
  "113": { name: "Cuba", flag: "🇨🇺" },
  "114": { name: "Mauritania", flag: "🇲🇷" },
  "115": { name: "Sierra Leona", flag: "🇸🇱" },
  "116": { name: "Jordania", flag: "🇯🇴" },
  "117": { name: "Portugal", flag: "🇵🇹" },
  "118": { name: "Barbados", flag: "🇧🇧" },
  "119": { name: "Burundi", flag: "🇧🇮" },
  "120": { name: "Benín", flag: "🇧🇯" },
  "121": { name: "Brunéi", flag: "🇧🇳" },
  "122": { name: "Bahamas", flag: "🇧🇸" },
  "123": { name: "Botsuana", flag: "🇧🇼" },
  "124": { name: "Belice", flag: "🇧🇿" },
  "125": { name: "República Centroafricana", flag: "🇨🇫" },
  "126": { name: "Dominica", flag: "🇩🇲" },
  "127": { name: "Granada", flag: "🇬🇩" },
  "128": { name: "Georgia", flag: "🇬🇪" },
  "129": { name: "Grecia", flag: "🇬🇷" },
  "130": { name: "Guinea-Bisáu", flag: "🇬🇼" },
  "131": { name: "Guyana", flag: "🇬🇾" },
  "132": { name: "Islandia", flag: "🇮🇸" },
  "133": { name: "Comoras", flag: "🇰🇲" },
  "134": { name: "San Cristóbal y Nieves", flag: "🇰🇳" },
  "135": { name: "Liberia", flag: "🇱🇷" },
  "136": { name: "Lesoto", flag: "🇱🇸" },
  "137": { name: "Malaui", flag: "🇲🇼" },
  "138": { name: "Namibia", flag: "🇳🇦" },
  "139": { name: "Níger", flag: "🇳🇪" },
  "140": { name: "Ruanda", flag: "🇷🇼" },
  "141": { name: "Eslovaquia", flag: "🇸🇰" },
  "142": { name: "Surinam", flag: "🇸🇷" },
  "143": { name: "Tayikistán", flag: "🇹🇯" },
  "144": { name: "Mónaco", flag: "🇲🇨" },
  "145": { name: "Baréin", flag: "🇧🇭" },
  "146": { name: "Reunión", flag: "🇷🇪" },
  "147": { name: "Zambia", flag: "🇿🇲" },
  "148": { name: "Armenia", flag: "🇦🇲" },
  "149": { name: "Somalia", flag: "🇸🇴" },
  "150": { name: "Congo", flag: "🇨🇬" },
  "151": { name: "Chile", flag: "🇨🇱" },
  "152": { name: "Burkina Faso", flag: "🇧🇫" },
  "153": { name: "Líbano", flag: "🇱🇧" },
  "154": { name: "Gabón", flag: "🇬🇦" },
  "155": { name: "Albania", flag: "🇦🇱" },
  "156": { name: "Uruguay", flag: "🇺🇾" },
  "157": { name: "Mauricio", flag: "🇲🇺" },
  "158": { name: "Bután", flag: "🇧🇹" },
  "159": { name: "Maldivas", flag: "🇲🇻" },
  "160": { name: "Guadalupe", flag: "🇬🇵" },
  "161": { name: "Turkmenistán", flag: "🇹🇲" },
  "162": { name: "Guayana Francesa", flag: "🇬🇫" },
  "163": { name: "Finlandia", flag: "🇫🇮" },
  "164": { name: "Santa Lucía", flag: "🇱🇨" },
  "165": { name: "Luxemburgo", flag: "🇱🇺" },
  "166": { name: "San Vicente y las Granadinas", flag: "🇻🇨" },
  "167": { name: "Guinea Ecuatorial", flag: "🇬🇶" },
  "168": { name: "Yibuti", flag: "🇩🇯" },
  "169": { name: "Antigua y Barbuda", flag: "🇦🇬" },
  "170": { name: "Islas Caimán", flag: "🇰🇾" },
  "171": { name: "Montenegro", flag: "🇲🇪" },
  "172": { name: "Dinamarca", flag: "🇩🇰" },
  "173": { name: "Suiza", flag: "🇨🇭" },
  "174": { name: "Noruega", flag: "🇳🇴" },
  "175": { name: "Australia", flag: "🇦🇺" },
  "176": { name: "Eritrea", flag: "🇪🇷" },
  "177": { name: "Sudán del Sur", flag: "🇸🇸" },
  "178": { name: "Santo Tomé y Príncipe", flag: "🇸🇹" },
  "179": { name: "Aruba", flag: "🇦🇼" },
  "180": { name: "Montserrat", flag: "🇲🇸" },
  "181": { name: "Anguila", flag: "🇦🇮" },
  "182": { name: "Japón", flag: "🇯🇵" },
  "183": { name: "Macedonia del Norte", flag: "🇲🇰" },
  "184": { name: "Seychelles", flag: "🇸🇨" },
  "185": { name: "Nueva Caledonia", flag: "🇳🇨" },
  "186": { name: "Cabo Verde", flag: "🇨🇻" },
  "187": { name: "Estados Unidos", flag: "🇺🇸" },
  "188": { name: "Palestina", flag: "🇵🇸" },
  "189": { name: "Fiyi", flag: "🇫🇯" },
  "196": { name: "Singapur", flag: "🇸🇬" },
  "198": { name: "Samoa", flag: "🇼🇸" },
  "199": { name: "Malta", flag: "🇲🇹" },
  "200": { name: "Liechtenstein", flag: "🇱🇮" },
  "201": { name: "Gibraltar", flag: "🇬🇮" },
  "203": { name: "Kosovo", flag: "🇽🇰" },
  "204": { name: "Niue", flag: "🇳🇺" },
};

export const NAME_TO_FLAG: Record<string, string> = {
  russia: "🇷🇺",
  ukraine: "🇺🇦",
  kazakhstan: "🇰🇿",
  china: "🇨🇳",
  philippines: "🇵🇭",
  myanmar: "🇲🇲",
  indonesia: "🇮🇩",
  malaysia: "🇲🇾",
  kenya: "🇰🇪",
  tanzania: "🇹🇿",
  vietnam: "🇻🇳",
  kyrgyzstan: "🇰🇬",
  uzbekistan: "🇺🇿",
  "united states": "🇺🇸",
  usa: "🇺🇸",
  israel: "🇮🇱",
  "hong kong": "🇭🇰",
  poland: "🇵🇱",
  "united kingdom": "🇬🇧",
  england: "🇬🇧",
  uk: "🇬🇧",
  "great britain": "🇬🇧",
  madagascar: "🇲🇬",
  congo: "🇨🇬",
  nigeria: "🇳🇬",
  macau: "🇲🇴",
  macao: "🇲🇴",
  egypt: "🇪🇬",
  india: "🇮🇳",
  ireland: "🇮🇪",
  cambodia: "🇰🇭",
  laos: "🇱🇦",
  haiti: "🇭🇹",
  "ivory coast": "🇨🇮",
  gambia: "🇬🇲",
  serbia: "🇷🇸",
  yemen: "🇾🇪",
  "south africa": "🇿🇦",
  colombia: "🇨🇴",
  estonia: "🇪🇪",
  azerbaijan: "🇦🇿",
  canada: "🇨🇦",
  morocco: "🇲🇦",
  ghana: "🇬🇭",
  argentina: "🇦🇷",
  cameroon: "🇨🇲",
  chad: "🇹🇩",
  germany: "🇩🇪",
  lithuania: "🇱🇹",
  croatia: "🇭🇷",
  sweden: "🇸🇪",
  iraq: "🇮🇶",
  netherlands: "🇳🇱",
  latvia: "🇱🇻",
  austria: "🇦🇹",
  belarus: "🇧🇾",
  thailand: "🇹🇭",
  senegal: "🇸🇳",
  turkey: "🇹🇷",
  guinea: "🇬🇳",
  ethiopia: "🇪🇹",
  moldova: "🇲🇩",
  mongolia: "🇲🇳",
  pakistan: "🇵🇰",
  togo: "🇹🇬",
  slovenia: "🇸🇮",
  bangladesh: "🇧🇩",
  brazil: "🇧🇷",
  "sri lanka": "🇱🇰",
  nepal: "🇳🇵",
  trinidad: "🇹🇹",
  honduras: "🇭🇳",
  "costa rica": "🇨🇷",
  "el salvador": "🇸🇻",
  albania: "🇦🇱",
  "guinea-bissau": "🇬🇼",
  "saudi arabia": "🇸🇦",
  sudan: "🇸🇩",
  syria: "🇸🇾",
  benin: "🇧🇯",
  burundi: "🇧🇮",
  niger: "🇳🇪",
  rwanda: "🇷🇼",
  somalia: "🇸🇴",
  malawi: "🇲🇼",
  "sierra leone": "🇸🇱",
  palestine: "🇵🇸",
  zambia: "🇿🇲",
  mozambique: "🇲🇿",
  jordan: "🇯🇴",
  cuba: "🇨🇺",
  lesotho: "🇱🇸",
  liberia: "🇱🇷",
  mauritania: "🇲🇷",
  botswana: "🇧🇼",
  uruguay: "🇺🇾",
  "bosnia and herzegovina": "🇧🇦",
  macedonia: "🇲🇰",
  georgia: "🇬🇪",
  armenia: "🇦🇲",
  kosovo: "🇽🇰",
  afghanistan: "🇦🇫",
  "burkina faso": "🇧🇫",
  "equatorial guinea": "🇬🇶",
  zimbabwe: "🇿🇼",
  namibia: "🇳🇦",
  "dr congo": "🇨🇩",
  uganda: "🇺🇬",
  angola: "🇦🇴",
  mali: "🇲🇱",
  mexico: "🇲🇽",
  ecuador: "🇪🇨",
  bolivia: "🇧🇴",
  chile: "🇨🇱",
  venezuela: "🇻🇪",
  peru: "🇵🇪",
  paraguay: "🇵🇾",
  guatemala: "🇬🇹",
  nicaragua: "🇳🇮",
  panama: "🇵🇦",
  "dominican republic": "🇩🇴",
  singapore: "🇸🇬",
  taiwan: "🇹🇼",
  japan: "🇯🇵",
  "south korea": "🇰🇷",
  korea: "🇰🇷",
  tajikistan: "🇹🇯",
  turkmenistan: "🇹🇲",
  france: "🇫🇷",
  spain: "🇪🇸",
  italy: "🇮🇹",
  portugal: "🇵🇹",
  finland: "🇫🇮",
};

export function getCountryFlag(
  country?: string | number | null,
  countryNameFallback?: string,
): string {
  if (country === null || (country === undefined && !countryNameFallback)) return "🌐";

  const countryStr = String(country ?? "").trim();
  if (COUNTRIES_MAP[countryStr]) {
    return COUNTRIES_MAP[countryStr].flag;
  }

  const nameToTest = (countryNameFallback || countryStr).toLowerCase().trim();
  for (const [key, flag] of Object.entries(NAME_TO_FLAG)) {
    if (nameToTest.includes(key)) {
      return flag;
    }
  }

  // If the fallback string already contains a flag emoji
  if (countryNameFallback && /[\uD83C][\uDDE6-\uDDFF]/.test(countryNameFallback)) {
    const match = countryNameFallback.match(/[\uD83C][\uDDE6-\uDDFF]{2}/);
    if (match) return match[0];
  }

  return "🌐";
}

export function getCountryName(
  country?: string | number | null,
  countryNameFallback?: string,
): string {
  if (country === null || (country === undefined && !countryNameFallback))
    return "País desconocido";

  const countryStr = String(country ?? "").trim();
  if (COUNTRIES_MAP[countryStr]) {
    return COUNTRIES_MAP[countryStr].name;
  }

  if (countryNameFallback) {
    // Strip existing flag emojis if present
    const cleaned = countryNameFallback.replace(/[\uD83C][\uDDE6-\uDDFF]{2}/g, "").trim();
    if (cleaned) return cleaned;
  }

  if (/^\d+$/.test(countryStr)) {
    return `País ${countryStr}`;
  }

  return countryStr || "País desconocido";
}

export function getCountryDisplayName(
  country?: string | number | null,
  countryNameFallback?: string,
): string {
  const flag = getCountryFlag(country, countryNameFallback);
  const name = getCountryName(country, countryNameFallback);
  return `${flag} ${name}`;
}

export function normalizeText(str: string): string {
  if (!str) return "";
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function matchesCountry(
  searchQuery: string,
  countryId?: string | number | null,
  countryNameFallback?: string,
): boolean {
  if (!searchQuery || !searchQuery.trim()) return true;
  const q = normalizeText(searchQuery);
  const qRaw = searchQuery.trim().toLowerCase();

  const idStr = String(countryId ?? "").trim();
  if (idStr && idStr === qRaw) return true;

  const spanishName = getCountryName(countryId, countryNameFallback);
  if (normalizeText(spanishName).includes(q) || spanishName.toLowerCase().includes(qRaw))
    return true;

  if (countryNameFallback) {
    if (
      normalizeText(countryNameFallback).includes(q) ||
      countryNameFallback.toLowerCase().includes(qRaw)
    )
      return true;
  }

  // "spain" should also match the Spanish spelling and vice versa. This used to pin
  // Spain to id 198 by hand — the id the provider uses for Samoa — so typing "España"
  // in the picker surfaced a Samoan number. Match on the name, never on a literal id.
  if (
    (q === "spain" || q === "espana" || q === "esp" || q === "es") &&
    (spanishName.toLowerCase().includes("españa") ||
      (countryNameFallback && countryNameFallback.toLowerCase().includes("spain")))
  ) {
    return true;
  }

  return false;
}
